import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import {
  delete_icon,
  edit_icon,
  eye_icon,
  left_arrow,
  no_image,
  password_icon,
  search_icon,
  toggle_off,
  toggle_on,
  user_profile,
  view_icon,
} from "../../assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import { admin_list } from "../redux/api/dummyJson";
import CancelIcon from "@mui/icons-material/Cancel";
import { useLazyOwnersListViewQuery } from "../redux/api/api";
import moment from "moment";

const OwnersView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [popup, setPopup] = useState(false);
  const [list, setList] = useState([]);
  const [type, setType] = useState();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [secMobile, setSecMobile] = useState();
  const [gender, setGender] = useState();
  const [address, setAddress] = useState();
  const [profileImage, setProfileImage] = useState();

  const id = location?.state?.id;
  console.log("id", id);

  const [ownersViewApi] = useLazyOwnersListViewQuery();

  const ownersListView = (id) => {
    ownersViewApi(id)
      .unwrap()
      .then((res) => {
        console.log("res", res);
        let value = Array.isArray(res?.data?.properties)
          ? res?.data?.properties
          : Object.values(res?.data?.properties);
        const flatData =
          Array.isArray(res?.data?.properties) &&
          typeof res?.data?.properties === "object" &&
          !Array.isArray(res?.data?.properties)
            ? Object.values(res?.data?.properties)
            : res?.data?.properties;

        // setProperties(flatData);

        setList(value || []);
        setName(res?.data?.name);
        setEmail(res?.data?.email);
        setMobile(res?.data?.mobile);
        setAddress(res?.data?.address);
        setGender(res?.data?.gender);
        setSecMobile(res?.data?.secondary_number);
        setProfileImage(res?.data?.image ? res?.data?.image : no_image);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (id) {
      ownersListView(id);
    }
  }, []);

  const [active, setActive] = useState("Profile");

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: "Property ID",
        accessor: "property_id",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {" "}
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", { state: { data: row.original } })
                }
              >
                {value}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Property Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {" "}
              <p
                className="pointer hoverline"
                onClick={() =>
                  navigate("/property-view", { state: { data: row.original } })
                }
              >
                {value}
              </p>
            </div>
          );
        },
      },
      {
        Header: "city",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Total Bookings",
        accessor: "bookings_count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Date & Time",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD-MM-YYYY, hh.mm.ss a")}</p>;
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc">
                <button
                  onClick={() =>
                    navigate(
                      "/property-view",
                      { state: { data: row.original } },
                      setType("add")
                    )
                  }
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className="mx-2 edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );
  console.log("list", list);

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
          Owners view
        </h2>
        <div
          onClick={() => {
            setPopup(true);
          }}
          className="d-flex gap-2"
        >
          <img
            src={profileImage}
            onChange={(e) => setProfileImage(e.target.value)}
            className="profile-img "
          />
        </div>
      </div>
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div
              className="d-flex ac-je pointer"
              onClick={() => setPopup(false)}
            >
              <CancelIcon />
            </div>
            <div className="profile-img-pop">
              <img
                style={{ width: "300px", height: "300px" }}
                src={profileImage}
                alt=""
                className="w-100 mt-3"
              />
            </div>
          </div>
        </div>
      )}

      <div className="d-flex ac-js gap-3" style={{ cursor: "pointer" }}>
        <div
          className={`${active === "Profile" ? "line-btm" : ""}`} // Apply 'line-btm' only if active
          onClick={() => setActive("Profile")}
        >
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-18 fs-xxl-20 mt-2 mb-0">
            Owner
          </p>
        </div>
        <div
          className={`${active === "Booking" ? "line-btm" : ""}`} // Apply 'line-btm' only if active
          onClick={() => setActive("Booking")}
        >
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-18 fs-xxl-20 mt-2 mb-0">
            Property
          </p>
        </div>
      </div>

      <div className="d-flex ac-js gap-2 mt-3" onClick={() => navigate(-1)}>
        <img src={left_arrow} className="leftArrow mb-3" />
        <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
          Back
        </p>
      </div>

      {active == "Booking" ? (
        <div>
          <Table columns={columns} data={list} />
        </div>
      ) : (
        <div className="">
          <div className="d-flex gap-5 mb-4">
            <div className="col-md-5">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                Owner Name
              </h4>
              <input
                type="text"
                readOnly
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="input-pop ps-2 w-100"
                placeholder="Owner Name"
              />
            </div>
            <div className="col-md-5">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                Mobile Number
              </h4>
              <input
                type="number"
                readOnly
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className="input-pop ps-2 w-100"
                placeholder="Mobile Number"
              />
            </div>
          </div>
          <div className="d-flex gap-5 mb-4">
            <div className="col-md-5">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                Secondary Mobile Number
              </h4>
              <input
                type="number"
                readOnly
                value={secMobile}
                onChange={(e) => setSecMobile(e.target.value)}
                className="input-pop ps-2 w-100"
                placeholder="Secondary Mobile Number"
              />
            </div>
            <div className="col-md-5">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                Owner Email
              </h4>
              <input
                type="email"
                readOnly
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-pop ps-2 w-100"
                placeholder="Albert@gmail.com"
              />
            </div>
          </div>
          <div className="d-flex gap-5 mb-4">
            <div className="col-md-5">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                Address
              </h4>
              <textarea
                type="text"
                readOnly
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="input-pop ps-2 w-100 h-100"
                placeholder="Address"
              />
            </div>
            <div className="col-md-5">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                Gender
              </h4>
              <input
                type="text"
                readOnly
                value={gender == 1 ? "Male" : gender == 2 ? "Female" : ""}
                onChange={(e) => setGender(e.target.value)}
                className="input-pop ps-2 w-100"
                placeholder="Address"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OwnersView;
